import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "setValue", "readonly", "min", "max", "step", "placeholder", "customProps"];
import React, { useMemo } from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { NumericFormat } from "react-number-format";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    readonly = props.readonly,
    min = props.min,
    max = props.max,
    step = props.step,
    placeholder = props.placeholder,
    customProps = props.customProps,
    numericFormatProps = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(values) {
    var val = values.floatValue;
    setValue(val === undefined ? null : val);
  };
  var numberValue = value == undefined ? "" : value;
  var InputProps = useMemo(function () {
    return {
      readOnly: readonly
    };
  }, [readonly]);
  var inputProps = useMemo(function () {
    return {
      min: min,
      max: max
    };
  }, [min, max, step]);
  return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(NumericFormat, _extends({
    size: "small",
    customInput: TextField,
    value: numberValue,
    placeholder: !readonly ? placeholder : "",
    InputProps: InputProps,
    inputProps: inputProps,
    disabled: readonly,
    onValueChange: handleChange
  }, customProps, numericFormatProps)));
});